import type { ClientRect, KeyboardCoordinateGetter } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Tastatursteuerung ueber Spaltengrenzen hinweg.
 *
 * `sortableKeyboardCoordinates` springt nur von Karte zu Karte. In eine LEERE
 * Spalte kommt man damit nie — ausgerechnet die Erledigt-Spalte ist aber
 * meistens leer, und sie ist das haeufigste Ziel ueberhaupt. Fuer
 * Tastaturnutzer waere die App damit an der wichtigsten Stelle unbedienbar.
 *
 * Deshalb: erst der eingebaute Weg, und wenn der nicht weiterkommt, die
 * naechste Spalte in Pfeilrichtung ansteuern.
 */
export const boardKeyboardCoordinates: KeyboardCoordinateGetter = (event, args) => {
  const fromSortable = sortableKeyboardCoordinates(event, args);
  if (fromSortable) return fromSortable;

  const direction = event.code === 'ArrowRight' ? 1 : event.code === 'ArrowLeft' ? -1 : 0;
  if (direction === 0) return undefined;

  const { context, currentCoordinates } = args;
  const active = context.collisionRect;
  if (!active) return undefined;

  const target = context.droppableContainers
    .toArray()
    .filter((container) => container.data.current?.type === 'column')
    .map((container) => container.rect.current)
    .filter((rect): rect is ClientRect => Boolean(rect))
    .filter((rect) => (direction > 0 ? rect.left > active.left + 1 : rect.left < active.left - 1))
    .sort((a, b) => (direction > 0 ? a.left - b.left : b.left - a.left))[0];

  if (!target) return undefined;

  return {
    x: currentCoordinates.x + (target.left - active.left),
    y: currentCoordinates.y,
  };
};
